<template>
  <div v-if="!loading" class="custom-margin-full-page">
    <v-row>
      <v-col cols="12" class="text-left">
        <v-icon color="warning" @click="$router.push('/dashboard')">mdi-arrow-left</v-icon>
      </v-col>
      <v-col cols="3">
        <v-text-field label="نام و نام خانوادگی" v-model="student.name" color="black"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field color="black" label="شماره همراه" v-model="student.mobile"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field label="ایمیل" type="email" v-model="student.email" color="black"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select color="black" v-model="student.gender"
                  label="جنسیت"
                  :items="[{text:'خانم',value:'female'},{text:'آقا',value:'male'}]"
        >
        </v-select>
      </v-col>
      <v-col cols="1">
        <vue-persian-datetime-picker color="black" v-model="student.birth_date"
                                     type="date"
                                     custom-input="#birth_date"
                                     auto-submit></vue-persian-datetime-picker>
        <v-text-field label="تاریخ تولد" v-model="student.birth_date" id="birth_date"
                      color="black">
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field label="عکس پروفایل"
                      @click="profileImageDialog = true" prepend-icon="mdi-plus"
                      color="black"
                      v-model="student.profile_image"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field color="black" persistent-hint
                      hint="در صورت خالی گذاشتن فیلد های رمز عبور  ، رمز عبور شما تغییر نخواهد کرد." label="رمز عبور"
                      v-model="student.password"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field color="black" label="تکرار رمز عبور"
                      hint="رمز عبور خود را دقیقا دوباره تایپ کنید. (از کپی کردن رمز عبور خود داری کنید)"
                      v-model="student.password_confirmation"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select color="black" :items="states" item-text="label" item-value="id" label="استان محل سکونت"
                  @change="getCities()" v-model="student.state_id"></v-select>
      </v-col>
      <v-col cols="2">
        <v-select v-if="cities.length" color="black" :items="cities" item-text="label" item-value="id"
                  label="شهر محل سکونت"
                  v-model="student.city_id"
        ></v-select>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn width="200px" color="#1ab69d" @click="updateProfile()" class="normal-button">ویرایش</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider class="my-4"></v-divider>
      </v-col>
      <v-col cols="12">
        <v-card-title class="pa-0">فعالیت‌های اخیر</v-card-title>
      </v-col>
      <v-col cols="12">
        <v-alert type="info" dense text v-if="!student.recent_activities || !student.recent_activities.length">
          هنوز فعالیتی ثبت نشده است.
        </v-alert>
        <v-data-table
            v-else
            :headers="activityHeaders"
            :items="student.recent_activities"
            dense
            hide-default-footer
        >
        </v-data-table>
      </v-col>
      <v-dialog v-model="profileImageDialog" max-width="50vw">
        <drag-and-drop-mobile module="course" ref="image-uploader" @closeUploadFileDialog="profileImageDialog = false"
                              @changeFile="student.profile_image = $event"></drag-and-drop-mobile>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import DragAndDropMobile from "@/components/Components/Mobile/UploadFile/DragAndDropMobile";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "ProfileDesktop",
  components: {DragAndDropMobile, VuePersianDatetimePicker},
  data() {
    return {
      loading: true,
      profileImageDialog: false,
      states: [],
      cities: [],
      student: {
        name: null,
        email: null,
        birth_date: null,
        gender: null,
        mobile: null,
        password: null,
        profile_image: null,
        state_id: null,
        city_id: null,
        school_id: null,
        status: null,
        last_visit: null,
        last_upload: null,
        recent_activities: []
      },
      activityHeaders: [
        { text: 'زمان', value: 'created_at_fa' },
        { text: 'آخرین فعالیت', value: 'title_fa' },
        { text: 'صفحه', value: 'route_path' }
      ]
    }
  },
  mounted() {
    this.student = this.$store.state.user
    this.student.birth_date = this.student.birth_date_fa
    this.getStates()
    this.getCities()
  },
  methods: {
    updateProfile() {
      window.axios.post('/student/profile/update', this.student).then(() => {
        this.openSnackbar('ویرایش پروفایل شما با موفقیت انجام شد.', '#1ab69d')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getStates() {
      window.axios.get('/system/state/index').then((res) => {
        this.states = res.data.data
      })
    },
    getCities() {
      window.axios.get('/system/city/index?state_id=' + this.student.state_id).then((res) => {
        this.cities = res.data.data
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 10vw 0 10vw;
}
.normal-button{
  letter-spacing: normal;
  color: white;
}
</style>
